<script lang="ts" setup>
import { ref } from 'vue'
import { $fetch } from '@/home/plugins/fetch';

const today = new Date();
const isSubscribe = ref(false);
const subscribeParams = ref({ name: '',  email: '' });
const isCorrect = ref({ name: true, email: true });

const postSubscribe = async () => {
  const { isSuccess } =  await $fetch('/email/v1/subscribe', {
    data: { ...subscribeParams.value, source: 1 },
  })
  if (isSuccess) {
    isSubscribe.value = true;
  } else {
    isSubscribe.value = false;
  }
}

const handleSubscribe = () => {
  const isEmailValidResult = isEmailValid(subscribeParams.value.email);
  const isNameValidResult = isNameValid(subscribeParams.value.name);

  isCorrect.value.email = isEmailValidResult;
  isCorrect.value.name = isNameValidResult;

  if (isEmailValidResult && isNameValidResult) {
    postSubscribe()
  }
};

// 文本格式校验
function isEmailValid(email: string) {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
}
function isNameValid(name: string) {
  const pattern = !!name;
  return  pattern;
}
</script>

<template>
  <footer class="page-footer w-full bg-#002b4e">
    <div class="mx-auto pb-30 pt-48 <sm:px-16 <xl:px-24" :class="$route.path === '/' ? 'max-w-1200' : 'max-w-1360 <2xl:max-w-1200'">
      <div class="">
        <h2 class="m-0 text-38 color-hex-FFFFFF font-800 leading-56 tracking--1.5 <md:text-28 <md:leading-36">{{ $t('footer.emailTitle') }}</h2>
        <p class="m-0 mt-12 text-16 color-hex-FFFFFF font-400 leading-32">{{ $t('footer.emailInfo') }}</p>
        <div>
          <div v-if="isSubscribe" class="mt-24 h-56 rounded-4 bg-#1180FF text-center text-20 color-hex-FFFFFF font-500 leading-56">{{ $t('footer.subscribeSuccess') }}</div>
          <div class="mt-24 h-80 flex justify-between <md:h-auto <md:flex-col <md:gap-16" v-else>
            <div>
              <input type="text" name="fullname" autocomplete="off" :placeholder="$t('footer.placegolderName')" v-model.trim="subscribeParams.name" class="h-54 w-400 border-1 rounded-6 bg-#50728d pl-24 text-16 color-hex-FFFFFF/55 font-400 leading-24 outline-none <md:w-full placeholder:text-white/50 placeholder:font-400">
              <div v-if="!isCorrect.name" class="mt-4 text-14 color-hex-FF4D4F font-400 leading-20">{{ $t('footer.nameError') }}</div>
            </div>
            <div>
              <input type="text" name="email" autocomplete="off" :placeholder="$t('footer.placegolderEmail')" v-model="subscribeParams.email" class="h-54 w-400 border-1 rounded-6 bg-#50728d pl-24 text-16 color-hex-FFFFFF/55 font-400 leading-24 outline-none <md:w-full placeholder:text-white/50 placeholder:font-400">
              <div v-if="!isCorrect.email" class="mt-4 text-14 color-hex-FF4D4F font-400 leading-20">{{ $t('footer.emailError') }}</div>
            </div>
            <button type="button" class="h-54 w-140 cursor-pointer border-0 rounded-4 bg-#FFF text-16 color-hex-292D33 font-600 leading-24 <md:w-full" @click="handleSubscribe()">
              {{ $t('footer.subscribe') }}
            </button>
          </div>
        </div>
        <div class="mb-50 mt-28 h-1 w-full bg-hex-FFFFFF/50"></div>
      </div>

      <div class="flex gap-74 <xl:flex-col <xl:gap-32">
        <div class="w-285 <xl:w-full">
          <img class="lazyload h-46 w-232 object-contain" data-src="@/home/assets/common/logo-with-title-white.svg" alt="LOGO">
          <p class="m-0 mt-20 text-14 text-#9497a1 font-normal leading-24">{{ $t('footer.information') }}</p>
          <ul class="m-0 mt-20 flex list-none gap-15 p-0">
            <li class="i-home-icons:weibo size-40 hover:i-home-icons:weibo-hover hover:size-40">
              <a class="block h-full w-full" href="https://weibo.com/u/7839689482" target="_blank" aria-label="weibo"></a>
            </li>
            <li class="group i-home-icons:tiktok relative size-40 hover:i-home-icons:tiktok-hover hover:size-40">
              <img class="lazyload absolute left--50 top--160 hidden size-130 rounded-4 bg-#fff object-cover p-10 group-hover:block" data-src="https://res.oafimg.cn/-/5f42f886a1f2c3d7/tiktok.jpg" alt="tiktok">
            </li>
            <li class="group relative size-40 bg-[url(@/home/assets/common/wechat-video.png)] bg-cover bg-no-repeat hover:bg-[url(@/home/assets/common/wechat-video-hover.png)]">
              <img class="lazyload absolute left--50 top--160 hidden size-130 rounded-4 bg-#fff p-10 group-hover:block" data-src="https://res.oafimg.cn/-/49b3044892e59392/wechat-video.jpg" alt="wechat video">
            </li>
            <li class="group i-home-icons:wechat relative size-40 hover:i-home-icons:wechat-hover">
              <img class="lazyload absolute left--50 top--160 hidden size-130 rounded-4 bg-#fff p-10 group-hover:block" data-src="https://res.oafimg.cn/-/1ed49cd64a791286/wechat.png" alt="wechat">
            </li>
            <li class="i-home-icons:bilibili size-40 hover:i-home-icons:bilibili-hover">
              <a class="block h-full w-full" href="https://space.bilibili.com/672606361" target="_blank" aria-label="BiliBili"></a>
            </li>
          </ul>
        </div>

        <div class="mt-10 w-840 flex flex-1 justify-between <md:w-full <md:flex-col <md:gap-24">
          <div>
            <div class="text-16 text-#fff font-700 leading-24">{{ $t('footer.info') }}</div>
            <ul class="m-0 mt-30 list-none p-0 text-14 text-#718096 font-400 leading-24 space-y-12">
              <li>
                <a href="/privacy-policy" target="_blank" class="text-#718096 no-underline hover:underline">{{ $t('footer.content1') }}</a>
              </li>
              <li>
                <a href="/terms" target="_blank" class="text-#718096 no-underline hover:underline">{{ $t('footer.content2') }}</a>
              </li>
              <li>
                <a href="/brand-guide" target="_blank" class="text-#718096 no-underline hover:underline">{{ $t('footer.content3') }}</a>
              </li>
              <li>
                <a href="https://atomgit.com/openatomfoundation/brand-identity" target="_blank" class="text-#718096 no-underline hover:underline">{{ $t('footer.content4') }}</a>
              </li>
            </ul>
          </div>
          <div>
            <div class="text-16 text-#fff font-700 leading-24">{{ $t('websiteTitle.contact') }}</div>
            <ul class="m-0 mt-30 flex-col list-none p-0 text-14 text-#718096 font-400 leading-24 space-y-12">
              <li>{{ $t('footer.content5') }}media@openatom.org</li>
              <li>{{ $t('footer.content6') }}report@openatom.org</li>
              <li>{{ $t('footer.content11') }}legal@openatom.org</li>
              <li>{{ $t('footer.content8') }}hr@openatom.org</li>
            </ul>
          </div>
          <div>
            <div class="text-16 text-#fff font-700 leading-24">{{ $t('websiteTitle.about') }}</div>
            <ul class="m-0 mt-30 list-none p-0 text-14 text-#718096 font-400 leading-24 space-y-12">
              <li>{{ $t('footer.address') }}</li>
              <li>{{ $t('footer.content9') }}sponsorship@openatom.org</li>
              <li>{{ $t('footer.content10') }}foss-project@openatom.org</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="mb-34 mt-48 border-t-1 border-#607D94 border-t-solid"></div>
      <div class="flex justify-between text-14 text-#607d94 font-normal leading-24 <md:flex-col <md:gap-12">
        <p class="m-0">
          Copyright {{ today.getFullYear() }} OPENATOM FOUNDATION. All rights reserved.
        </p>
        <p class="m-0">
          {{ $t('footer.content12') }}
          <a href="https://beian.miit.gov.cn/" target="_blank" class="text-#607d94 no-underline hover:underline">{{ $t('footer.beian') }}</a>
          <img data-src="https://res.oafimg.cn/-/e2468638b6adb4de/police.png" width="16" height="16" class="lazyload mx-5 align-[-3px]" alt="police">
          <span>{{ $t('footer.content13') }}</span>
        </p>
      </div>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
</style>
